import randomString from "@packages/random-string";
import Vue from "vue";
import parent from "../advertising";

export default {
    url({ advertisingId, path = "" }) {
        if (!advertisingId) throw Error("Undefined parent id");

        return `${parent.url()}/${advertisingId}/interacao${path}`;
    },

    async load(advertisingId) {
        const url = this.url({ advertisingId });

        return await Vue.http.get(`${url}`);
    },

    async create({ advertisingId, data }) {
        const url = this.url({ advertisingId });
        const defaultInteraction = {
            nome: randomString(),
            descricao: null,
            tipo: "BANNER",
            estilo: null,
            posicaoX: 1,
            posicaoY: 1,
            campanhaId: advertisingId,
        };
        data = { ...defaultInteraction, ...data };

        return Vue.http.post(url, data);
    },

    async update({ interactionId, advertisingId, data }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}`,
        });

        if (data.estilo || typeof data.estilo === "string")
            data.estilo = JSON.stringify(data.estilo);

        return await Vue.http.patch(url, data);
    },

    async remove({ id, advertisingId }) {
        const url = this.url({
            advertisingId,
            path: `/${id}`,
        });

        return await Vue.http.delete(url);
    },

    async background({ interactionId, advertisingId, data }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/background`,
        });

        const options = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };

        return await Vue.http.post(url, data, options);
    },

    async removeBackground({ interactionId, advertisingId, isMobile }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/background?isMobile=${isMobile}`,
        });

        return await Vue.http.delete(url);
    },

    async bindInteraction({ interactionId, advertisingId, nextId }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/vinculo/${nextId}`,
        });

        return Vue.http.post(url);
    },

    async unbindInteraction({ interactionId, advertisingId }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/vinculo`,
        });

        return Vue.http.delete(url);
    },

    async setIntegration({ advertisingId, integrationId, interactionId }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/integracao/${integrationId}`,
        });

        return Vue.http.post(url, {});
    },

    async unsetIntegration({ advertisingId, interactionId }) {
        const url = this.url({
            advertisingId,
            path: `/${interactionId}/integracao`,
        });

        return Vue.http.delete(url);
    },
};
